function layoutSwitcher() {
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
    link.addEventListener('click', toggle);
    link.addEventListener('keydown', handleKeyDown);
  });
};
function handleKeyDown(event){
  if (event.keyCode === 13) {
    toggle(event);
  }
}
function toggle(event){
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
  event.currentTarget.classList.add('active');
  if(event.currentTarget.classList.contains('listv')){
    document.getElementById('ProductGridContainer').classList.add('product-list');
    document.getElementById('ProductGridContainer').classList.remove('product-grid');
  }else if(event.currentTarget.classList.contains('gridv')){
    document.getElementById('ProductGridContainer').classList.add('product-grid');
    document.getElementById('ProductGridContainer').classList.remove('product-list');
  }
}
document.addEventListener("shopify:section:load", layoutSwitcher);
layoutSwitcher();

// on scroll play video
window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);
function videoScroll() {
  var videoEl = document.querySelectorAll('video[autoplay], video.card__video');
  if (!videoEl.length) return;
  var windowHeight = window.innerHeight;
  for (var i = 0; i < videoEl.length; i++) {
    var thisVideoEl = videoEl[i];
    if (thisVideoEl.classList.contains('card__video--hover')) continue;
    thisVideoEl.muted = true;
    thisVideoEl.playsInline = true;
    var videoHeight = thisVideoEl.clientHeight || thisVideoEl.parentElement.clientHeight;
    var videoClientRect = thisVideoEl.getBoundingClientRect().top;
    if (videoClientRect <= windowHeight - videoHeight * 0.5 && videoClientRect >= 0 - videoHeight * 0.5) {
      var playPromise = thisVideoEl.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    } else {
      thisVideoEl.pause();
    }
  }
}

function bindCardHoverVideos(root) {
  var inners = (root || document).querySelectorAll('.card__inner');
  for (var i = 0; i < inners.length; i++) {
    var inner = inners[i];
    var hoverVideo = inner.querySelector('video.card__video--hover');
    if (!hoverVideo || inner.dataset.hoverVideoBound) continue;
    inner.dataset.hoverVideoBound = '1';
    inner.addEventListener('mouseenter', function () {
      var hover = this.querySelector('video.card__video--hover');
      var primary = this.querySelector('video.card__video:not(.card__video--hover)');
      if (primary) primary.pause();
      if (!hover) return;
      hover.muted = true;
      hover.playsInline = true;
      var playPromise = hover.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    });
    inner.addEventListener('mouseleave', function () {
      var hover = this.querySelector('video.card__video--hover');
      var primary = this.querySelector('video.card__video:not(.card__video--hover)');
      if (hover) hover.pause();
      if (primary) {
        var playPromise = primary.play();
        if (playPromise && playPromise.catch) playPromise.catch(function () {});
      }
    });
  }
}
document.addEventListener('shopify:section:load', function (event) {
  bindCardHoverVideos(event.target);
});
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { bindCardHoverVideos(); });
} else {
  bindCardHoverVideos();
}

document.addEventListener('DOMContentLoaded', () => {
  const countdowns = [];

  document.querySelectorAll('.countd_all').forEach(section => {
    const targetDate = new Date(section.dataset.date).getTime();

    countdowns.push({
      section,
      targetDate,
      days: section.querySelector('.wb_cdays'),
      hours: section.querySelector('.wb_chours'),
      minutes: section.querySelector('.wb_cminutes'),
      seconds: section.querySelector('.wb_cseconds')
    });
  });

  if (!countdowns.length) return;

  let timerStarted = false;
  let timerId = null;

  function updateCountdowns() {
    const now = Date.now();

    countdowns.forEach(item => {
      if (isNaN(item.targetDate)) return;

      const distance = item.targetDate - now;

      if (distance <= 0) {
        item.days && (item.days.textContent = '00');
        item.hours && (item.hours.textContent = '00');
        item.minutes && (item.minutes.textContent = '00');
        item.seconds && (item.seconds.textContent = '00');
        return;
      }

      item.days && (item.days.textContent = String(Math.floor(distance / 86400000)).padStart(2, '0'));
      item.hours && (item.hours.textContent = String(Math.floor((distance % 86400000) / 3600000)).padStart(2, '0'));
      item.minutes && (item.minutes.textContent = String(Math.floor((distance % 3600000) / 60000)).padStart(2, '0'));
      item.seconds && (item.seconds.textContent = String(Math.floor((distance % 60000) / 1000)).padStart(2, '0'));
    });

    timerId = setTimeout(updateCountdowns, 1000);
  }

  function startCountdown() {
    if (timerStarted) return;

    timerStarted = true;
    updateCountdowns();
  }

  // Observe all countdown sections instead of only the first one
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        observer.disconnect();

        if (window.requestIdleCallback) {
          requestIdleCallback(startCountdown);
        } else {
          setTimeout(startCountdown, 200);
        }
      }
    });
  }, {
    rootMargin: '200px'
  });

  countdowns.forEach(item => {
    observer.observe(item.section);
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      clearTimeout(timerId);
      timerStarted = false;
    } else {
      const hasVisibleCountdown = countdowns.some(item => {
        const rect = item.section.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
      });

      if (hasVisibleCountdown) {
        startCountdown();
      }
    }
  });
});
